export default __webpack_public_path__ + "static/media/WorkspaceReminderWeb.b553bebe.png";